import { CREATE_NEW_POST_SUCCESS, REQUEST_GET_ALL_FILES_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function getPostUserData(state = INITIAL_STATE, action) {

    switch (action.type) {
        case CREATE_NEW_POST_SUCCESS:
            return { ...state, posts: action.payload.data, errors: null }
        case REQUEST_GET_ALL_FILES_SUCCESS:
            return {
                ...state,
                media: action.payload.data.media,
                errors: null
            };
        default:
            return state;
    }
}